/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div
    :style="{...(props.remarkWidth ? {'--remarkWidth': props.remarkWidth + 'px'} : {}), ...(props.backgroundColor ? {'--bgColor': props.backgroundColor} : {}), ...elCtlStyle}"
    :class="[props.labelPosition,props.remarkPosition?'remarkLeft':'']"
    v-if="hiddenState!==false"
      class="xmInput xmFileUpload">
    <xm-form-item v-if="showLabel"
                  :props="props"
                  :propKey="model.key"/>
    <xm-file-input
      v-bind="fileInputProps"
      :ctlProps="props"
      :showFileTypes="props.showFileTypes"
      :accept="props.fileTypes"
      :fileAclInfo="fileAclInfo"
      :tepFileName="props.tepFileName"
      :multiple="props.multiple"
      :filetype="filetype||props.filetype"
      :downUrl="props.downUrl"
      :tableCode="props.tableCode"
      :disabled="fileInputDisabled"
      @done="doneFile"
      ref="xmFileInputRef"
      listType="file"
      :fileTempDownUrl="props['downUploadUrl']"
      :tempDownLink="props.tempDownLink"
      :fileId="fileId"
    >
      <template v-if="props.userFileTemp" #userTemp="{fileList,fileCtls}">
        <slot name="userTemp" :fileList="fileList" :fileCtls="fileCtls"></slot>
      </template>
    </xm-file-input>
    <el-remark :props="props"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmFileUploadCtl",
});
</script>

<script lang="ts" setup>
import ElRemark from "@/main-page-form/common/el-remark.vue";
import XmFormItem from "@/main-page/commonVue/xm-form-item.vue";
import XmFileInput from "@/components/xmFileComCtl/xm-file-input.vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {initPropDefValues} from "@/utils";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {useFieldStateHooks} from "@/main-page-form/hooks/useFieldCtlStateHooks";
import {useFileUploadHook} from "@/main-page-form/ctls/fileCtls/hooks/useFileUploadHook";
import {useFileUploadConfig} from "@/main-page-form/ctls/fileCtls/hooks/useFileUploadConfig";

interface propTypes {
  props: any,
  events: any,
  styles: any,
  filetype:string;
  showLabel: boolean,
  model: any,
  fileId:string,
  pItemFormKey: string,
  pModelObj: any,
  pItem: string,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  showLabel: true,
  pItem: '',
  filetype:'',
  fileId:'',
  styles: {},
  pItemFormKey: '',
  events: [],
  props: {},
  pModelObj: {},
  model: {},
});

const {props, styles, model, events, pItem, pModelObj}: any = toRefs(propsPage);
const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});

// 控件样式
const {elCtlStyle} = useCtlStyle({
  styles,
  props,
  propsStyl: ['width'],
  outExtendProp: unref(pItem) === 'xmForm' ? ['marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'paddingLeft'] : []
});

// 表单字段状态（依赖注入）
const formElAclInfos = inject('formElAclInfos');
const readOnlyTextPItem = inject('readOnlyTextPItem');
const disabledPItem = inject('disabledPItem');
const {
  disabledState,
  readOnlyState,
  hiddenState
} = useFieldStateHooks({vuex, props, model}, {disabledPItem, readOnlyTextPItem, formElAclInfos});

// 文件上传配置（提取到独立Hook）
const {
  busTempId,
  fileInputProps,
  fileAclInfo,
  fileInputDisabled,
  setupModelValueWatch,
  regenerateBusId
} = useFileUploadConfig({
  props,
  pModelObj,
  model,
  disabledState,
  readOnlyState,
  hiddenState
});

// 文件上传完成事件处理
const emits = defineEmits(['doneFile']);
const {doneFile} = useFileUploadHook({emits, busTempId, props, events, pModelObj, model});

// 文件输入组件引用
const xmFileInputRef = ref(null);

// 设置模型值监听
setupModelValueWatch(xmFileInputRef);

// 监听表单重置标志
watch(() => unref(props).initDefValFlag, (newVal) => {
  if (newVal) {
    nextTick(() => {
      // 重新生成 businessId
      regenerateBusId();
      // 清空文件列表
      (xmFileInputRef.value as any)?.clearFileList?.();
    });
  }
});

// 暴露获取文件列表方法
const getFileList = () => xmFileInputRef.value?.getFileList();
defineExpose({getFileList});


</script>

<style type="text/css" lang="less">

</style>
